import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center py-12 px-4 overflow-hidden bg-[#0f0f0f]" data-id="element-52">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-53">
        <div className="absolute top-[10%] left-[20%] w-64 h-64 bg-[#C9A84C] rounded-full opacity-[0.03] blur-[100px]" data-id="element-54"></div>
        <div className="absolute bottom-[20%] right-[10%] w-96 h-96 bg-blue-900 rounded-full opacity-[0.05] blur-[120px]" data-id="element-55"></div>
      </div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-56">
        {/* Text Content */}
        <div className="order-2 lg:order-1 text-center lg:text-left" data-id="element-57">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] mb-6 animate-fade-in" data-id="element-58">
            <span className="w-2 h-2 rounded-full bg-[#C9A84C] animate-pulse" data-id="element-59"></span>
            <span className="text-xs uppercase tracking-widest text-[#888] font-medium" data-id="element-60">
              El Azúcar Silencioso
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-3 text-white tracking-tight" data-id="element-61">
            Hay preguntas que solo nacen en una cama de hospital.
          </h1>

          <p className="text-xl md:text-2xl text-[#C9A84C] font-serif italic mb-8" data-id="element-62">
            Y ojalá alguien me hubiera ayudado a entenderlas antes.
          </p>

          <p className="text-lg md:text-xl text-[#9a9a9a] mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-light" data-id="element-63">
            Después de despertar de una cirugía cardíaca, entendí que había
            procesos ocurriendo dentro de mi cuerpo que nadie me había explicado
            con claridad.
            <br data-id="element-64" />
            <br data-id="element-65" />
            Este libro nace de esa búsqueda: comprender lo que el azúcar puede
            hacer en silencio… y cómo esa información puede cambiar tus
            decisiones para siempre.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-66">
            <button onClick={() => document.getElementById('price-box')?.scrollIntoView({
            behavior: 'smooth'
          })} className="group relative bg-[#C9A84C] hover:bg-[#b09240] text-black font-semibold text-lg py-4 px-8 rounded-lg w-full md:w-auto transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] flex items-center justify-center gap-2" data-id="element-67">
              <span data-id="element-68">Sí, quiero empezar a leer</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-69" />
            </button>

            <p className="text-sm text-[#666] flex items-center gap-2" data-id="element-70">
              <ShieldCheck className="w-4 h-4 text-[#C9A84C]" data-id="element-71" />
              Optimizado para móvil • Acceso inmediato • Empieza hoy el plan de
              14 días
            </p>

            <p className="text-xs text-[#444] mt-2 border-t border-[#222] pt-2" data-id="element-72">
              Solo educativo — no es consejo médico
            </p>
          </div>
        </div>

        {/* Product Image */}
        <div className="order-1 lg:order-2 flex justify-center relative" data-id="element-73">
          <div className="relative w-full max-w-md lg:max-w-full aspect-square lg:aspect-auto flex items-center justify-center" data-id="element-74">
            <div className="absolute inset-0 bg-gradient-to-b from-[#C9A84C]/10 to-transparent rounded-full blur-3xl opacity-30" data-id="element-75"></div>
            <img src="https://cdn.magicpatterns.com/uploads/8utMpmgfTZd8LBxj1BvG6M/El_Azucar_Silenciosa_Portad_-_Pagina_de_Ventas.png" alt="Portada del Ebook El Azúcar Silencioso" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-700 ease-out" data-id="element-76" />
          </div>
        </div>
      </div>
    </section>;
}